import { ItemListCard } from '@app/components/blocks/card/ItemListCard'
import { useTranslations } from '@i18n/useLanguage'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { useMemo } from 'react'

export const HousingFormsCard = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app.topicCommunityPage
  const [, setLocation] = useLocation()

  const items = useMemo(() => {
    const housingForms = topicCommunity?.relatedHousingForms ?? []
    return housingForms.map((hf) => ({
      id: hf.id,
      title: hf.title,
      image: hf.images?.[0]?.src,
      onClick: () => hf.slug && setLocation(pages.housingForm(hf.slug)),
    }))
  }, [topicCommunity?.relatedHousingForms, setLocation])

  if (items.length === 0) {
    return null
  }

  return <ItemListCard title={t.relatedHousingFormsCard.title} items={items} />
}
